import React, { useState } from 'react';

const Podcasts = () => {
  const [showAll, setShowAll] = useState(false);
  const podcasts = [
     { 
    title: 'Sa ferme compte aujourd’hui plus de 400 porcs, partis de seulement 15 en trois ans' ,
    description: 'Découvrez comment cet éleveur passionné a développé son élevage de porcs de 15 à plus de 400 en un temps record grâce à son savoir-faire et sa persévérance.' ,
    url: 'https://www.youtube.com/embed/nVQuwwI3pho'
  },
  { 
    title: 'PASCAL PEUMENI : apprendre sans relâche, même après 5 ans d’expérience, une passion pour l’agropastoralisme' ,
    description: 'Rencontrez Pascal Peumeni, un éleveur et entrepreneur agricole qui continue d’apprendre et d’innover chaque jour dans le domaine de l’agropastoralisme.',
    url: 'https://www.youtube.com/embed/wC7s1kYb1x4'
  },
    { title: 'Il fait des analyses de sol à partir du satellite ', description: 'Incroyable! Il fait des analyses de sol à partir du satellite ', url: 'https://www.youtube.com/embed/ObQZ2NycHZQ?si=nlMaHXECfGk2ryWW' },
    { title: 'Cartographiez votre parcelle agricole', description: 'Cartographiez votre parcelle agricole en quelques clics avec SatelliteAgro', url: 'https://www.youtube.com/embed/LVHWCwQQaWI?si=5ImJsUFzE0Wl4sh5' },
    { title: 'Utiliser la carte de fertilité', description: 'utiliser la carte de fertilité', url: 'https://www.youtube.com/embed/Re8UmY9Puio?si=DE-drOoTqQQJ7coE' },
  ];

  return (
    <div>
      <section className="hero-section bg-light py-5">
            <div className="container text-center">
                <h1 className="display-4 fw-bold text-white">Écoutez nos histoires inspirantes</h1>
                <p className="lead text-white">
                Plongez dans l'univers de K'MDEU FARMS à travers nos podcasts. Découvrez nos méthodes de production, 
        nos engagements pour une agriculture durable et les histoires qui font de nous une entreprise unique.
                </p>
            </div>
        </section>
  <br></br>
  <div className="container mt-5">
          <h2>Nos PodCasts</h2>
          <div className="row text-center">
      {(showAll ? podcasts : podcasts.slice(0, 12)).map((podcast, index) => (
        <div key={index} className="col-md-4 mb-4">
            <div className="card h-100">
            <iframe width="560" height="315" src={podcast.url} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            <div className="card-body">
                <h3>{podcast.title}</h3>
                <p>{podcast.description}</p>
            </div>
            </div>
         </div>
      ))}
      <br></br>
      {podcasts.length > 2 && (
        <button className="btn btn-primary" onClick={() => setShowAll(!showAll)}>
          {showAll ? 'Afficher moins' : 'Afficher plus'}
        </button>
      )}
  
    </div>
    </div>
    <br></br>
    </div>
    
  );
};

export default Podcasts;